//Taost mesages codes
export const TOAST_CODES={
PHONE_EXIST : 'T0013',
PHONE_NOT_EXIST : 'T0046'
}